"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CarouselAutoplayButton: function() {
        return _index.CarouselAutoplayButton;
    },
    carouselAutoplayButtonClassNames: function() {
        return _index.carouselAutoplayButtonClassNames;
    },
    renderCarouselAutoplayButton_unstable: function() {
        return _index.renderCarouselAutoplayButton_unstable;
    },
    useCarouselAutoplayButtonStyles_unstable: function() {
        return _index.useCarouselAutoplayButtonStyles_unstable;
    },
    useCarouselAutoplayButton_unstable: function() {
        return _index.useCarouselAutoplayButton_unstable;
    }
});
const _index = require("./components/CarouselAutoplayButton/index");
